import React from 'react';
import { useApiLoadingPool, usePreventInfiniteLoading, useRouter, useScrollToTop, } from '@/util/hook/custom';
import useCallback from '@/util/hook/useCallback';
import useDispatch from '@/util/hook/useDispatch';
import useSelector from '@/util/hook/useSelector';
import { selectLiffId } from '@/util/redux/auth';
import { handleParamVerifyAndCachePut } from '../../util/helper/paramVerifyAndCachePut';
import { useGetCareClientVisitorProfile } from '../../util/hook/useGetCareClientVisitorProfile';
import { useGetRemoteConfig } from '../../util/hook/useGetRemoteConfig';
import { useScrollToInputField } from '../../util/hook/useScrollToInputField';
import { useTrackBrowserHistory } from '../../util/hook/useTrackBrowserHistory';
import { useValidateCareClientVisitorProfileAndRedirect } from '../../util/hook/useValidateCareClientVisitorProfileAndRedirect';
import { useValidateCareOrderBabyForm } from '../../util/hook/useValidateCareOrderBabyForm';
import { careOrderBabyFormUpdate, selectCareOrderBabyForm, } from '../../redux/module/careOrderBabyForm';
import { selectDoAgreePlatformPolicy, trackerDoAgreePlatformPolicySetFalse, trackerDoAgreePlatformPolicySetTrue, } from '../../redux/module/tracker';
import View from './View';
import { APP } from '../../config/app';
import { HOME_CARE_TITLE } from '../../config/option';
import { DEFAULT_NOTES_PLACEHOLDER, HOME_CARE_NOTES_PLACEHOLDER } from '../../config/placeholder';
import { CareOrderBabyFormForCachePutDConverter } from '../../util/dataConverter/CareOrderBabyFormForCachePutDConverter';
import { CareOrderBabyFormForParamVerifyDConverter } from '../../util/dataConverter/CareOrderBabyFormForParamVerifyDConverter';
export default function Controller() {
    const { isLoading, setLoading, setApiProcessingPool, setApiDonePool } = useApiLoadingPool(true);
    const _id = useSelector(selectLiffId);
    const careOrderBabyForm = useSelector(selectCareOrderBabyForm);
    const doAgreePlatformPolicy = useSelector(selectDoAgreePlatformPolicy);
    const { getIsFieldError, setErrorTypes } = useValidateCareOrderBabyForm({
        notes: careOrderBabyForm.notes,
    });
    const { careOrderBabyFormInputFieldRefMap, scrollToInputField } = useScrollToInputField();
    const { navigate, navigateError } = useRouter();
    const dispatch = useDispatch();
    useTrackBrowserHistory();
    useGetRemoteConfig({ setApiProcessingPool, setApiDonePool });
    useGetCareClientVisitorProfile({ setApiProcessingPool, setApiDonePool });
    useValidateCareClientVisitorProfileAndRedirect({ redirectRoute: null });
    useScrollToTop();
    usePreventInfiniteLoading({ setApiProcessingPool, setApiDonePool });
    const isNotesError = getIsFieldError('notes');
    const hospitalBed = careOrderBabyForm.hospitalBed;
    const isHomeCare = hospitalBed === HOME_CARE_TITLE;
    const notesTextareaRowCount = isHomeCare ? 10 : 8;
    const notesPlaceholder = isHomeCare ? HOME_CARE_NOTES_PLACEHOLDER : DEFAULT_NOTES_PLACEHOLDER;
    // event handlers
    const handleNotesTextareaChange = (e) => {
        const notes = e.target.value;
        dispatch(careOrderBabyFormUpdate({
            notes,
        }));
    };
    const handleAgreeCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            dispatch(trackerDoAgreePlatformPolicySetTrue());
        }
        else {
            dispatch(trackerDoAgreePlatformPolicySetFalse());
        }
    };
    const handleBackButtonClick = useCallback(() => {
        navigate(APP.ROUTES.CARE_REQUIREMENT);
    }, []);
    const handleForwardButtonClick = async () => {
        if (!doAgreePlatformPolicy) {
            dispatch(trackerDoAgreePlatformPolicySetFalse());
            return;
        }
        const { data: paramVerifyParams } = new CareOrderBabyFormForParamVerifyDConverter({
            notes: careOrderBabyForm.notes,
        });
        const { data: careOrderBabyFormForCachePut } = new CareOrderBabyFormForCachePutDConverter({
            careOrderBabyForm,
        });
        const { isSuccess } = await handleParamVerifyAndCachePut({
            _id,
            params: { _id, ...paramVerifyParams },
            careOrderBabyFormForCachePut,
            careOrderBabyFormInputFieldRefMap,
            setLoading,
            setErrorTypes,
            scrollToInputField,
            navigateError,
        });
        if (isSuccess) {
            navigate(APP.ROUTES.DATE_AND_TIME);
        }
    };
    return (<View 
    // data
    isLoading={isLoading} notes={careOrderBabyForm.notes} isNotesError={isNotesError} notesTextareaRowCount={notesTextareaRowCount} notesPlaceholder={notesPlaceholder} doAgreePlatformPolicy={doAgreePlatformPolicy} 
    // func
    handleNotesTextareaChange={handleNotesTextareaChange} handleAgreeCheckboxChange={handleAgreeCheckboxChange} handleBackButtonClick={handleBackButtonClick} handleForwardButtonClick={handleForwardButtonClick}/>);
}
